module.exports = __webpack_public_path__ + "media/images/mclaren_small-51014bc738e87ffb098f232c9510b472.png";